<script setup>
import {ref, onBeforeMount} from "vue"
import {tagsStateEnum} from "@/enum/tagsStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: Number,
    default: 0
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 订单状态枚举
const orderState = tagsStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const order = orderState.find(res => res.stateId === props.state)
    stateName.value = order.stateName ? order.stateName : "未知状态"
    switch (props.state) {
      case 1:
        textType.value = "success"
        break
      case 0:
        textType.value = "info"
        break
      case 2:
        textType.value = "warning"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-tag :type="textType" v-text="stateName"></el-tag>
</template>

<style scoped>

</style>
